/**
 * Admin screen to lookup transactions
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import withStyles from '@mui/styles/withStyles';
import LoadingSpinner from '../ui/LoadingSpinner';
import PageTitle from '../ui/PageTitle';
//import ReceivePaymentMutation from '../customer/ReceivePaymentMutation';
import { FormControl, Grid, InputLabel, MenuItem, Select, 
         Table, TableBody, TableCell, TableHead, TablePagination, 
         TableRow, TextField, Typography } from '@mui/material';
import SaveButton from '../ui/SaveButton';
import ServerError from '../ui/ServerError';
import SearchField from '../ui/SearchField';
import AppBindStyles from '../../AppBindStyles';
import { addDays, isValid, startOfDay, subMonths } from 'date-fns';

const abEnvironment = new AbEnvironment();
const TransactionsQuery = graphql`
query TransactionsQuery($extsource: String, $exttransactionid: String, $mode: Int, $transactiontype: Int, 
                        $startDate: Datetime, $endDate: Datetime, $first: Int, $offset: Int) {
  lookuptransactions(extsource: $extsource, exttransactionid: $exttransactionid, 
                     mode: $mode, transactiontype: $transactiontype,
                     startTs: $startDate, endTs: $endDate, first: $first, offset: $offset) {
    totalCount
    nodes {
      transactionId
      transactionType
      transactionTime
      description
      extSource
      extTransactionId
    }
  }
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
      //marginTop: 10,
    },
    flex: {
      flex: 1,
    },
    button: {
      marginLeft: theme.spacing(1),
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    dateField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginTop: 4,
      width: 180,
    },
    textField2: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      marginTop: 3,
      width: 160,
    },
    searchCaption: {
      marginTop: 1,
    },
    formControl: {
      margin: theme.spacing(1),
    },
    selectSearch: {
      marginRight: theme.spacing(1),
      marginTop: 0,
      marginLeft: 0,
      width: 100,
    },
    selectSearchWide: {
      marginRight: theme.spacing(1),
      marginTop: 0,
      marginLeft: 0,
      width: 180,
    },
    paper1: {
      padding: 16,
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    paper2: {
      padding: 12,
      textAlign: 'left',
      color: theme.palette.text.secondary,
    },
    paper3: {
      padding: 16,
      textAlign: 'center',
      color: theme.palette.text.secondary,
    }
});

class Transactions extends Component {
  constructor(props) {
    super(props);

    let cToDate = new Date();
    let tDate = localStorage.getItem('cToDate');
    if (tDate != null) {
      cToDate = new Date(tDate);
    }
    //search todate should be "start of next day"
    let searchToDateUtc = startOfDay(addDays(cToDate, 1)).toISOString();

    let cFromDate = new Date();
    let fDate = localStorage.getItem('cFromDate');
    if (fDate != null) {
      cFromDate = new Date(fDate);
    } else {
      cFromDate = subMonths(cToDate, 1);
    } 
    //search todate should be "start of next day"
    let searchFromDateUtc = startOfDay(cFromDate).toISOString();

    this.state = {
      saveStatus: null,
      saveMessage: null,
      saveSnackbarOpen: false,
      saveSnackbarDuration: null,
      extSource2: 'choose',   // Source for use in receiving payments
      extPayoutId: '',
      extSource: 'choose',    // Source for use in searching transactions
      extTransactionId: '',
      transactionType: -1,
      mode: 0,
      startDate: cFromDate,
      queryStartDateUtc: searchFromDateUtc,
      endDate: cToDate,
      queryEndDateUtc: searchToDateUtc,
      page: 0,
      rowsPerPage: 10,
    };  
  }

  goTo(url) {
    if (url == null)
      return;
      
    this.props.history.push(`${url}`);
  }        

  setFromDate(theDate) {
    let vdate = new Date(theDate);
    if (isValid(vdate)) {
      localStorage.setItem('cFromDate', theDate);
      let searchDateUtc = startOfDay(vdate).toISOString();
      this.setState({ startDate: theDate, queryStartDateUtc: searchDateUtc, page: 0 });
    }
  }

  setToDate(theDate) {
    let vdate = new Date(theDate);
    if (isValid(vdate)) {
      localStorage.setItem('cToDate', theDate);
      let searchDateUtc = startOfDay(addDays(vdate, 1)).toISOString();
      this.setState({ endDate: theDate, queryEndDateUtc: searchDateUtc, page: 0 });
    }
  }

  handleChange = name => event => {
    let newVal = event.target.value;
    if (newVal === '') {
      newVal = null;
    }
    this.setState({
      [name]: newVal,
      page: 0,
    });
  };

  handleChangePage = (event, page) => {
    this.setState({page: page});
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value});
  }

  /*** call the partner API to receive payout from Stripe or Dwolla ***/
  enterPayoutReceipts()
  {
    this.setState({ saveStatus: 'saving' });
    const { callPartnerApi } = this.props.auth;
    let extSource = this.state.extSource2;
    let extPayoutId = this.state.extPayoutId;

    if (extSource === 'dwolla') {
      // this.setState({ saveSnackbarOpen: true, saveStatus: 'error', saveMessage: 'Dwolla not yet supported', saveSnackbarDuration: null });
      Promise.resolve()
      .then(() => {
        // Receive a payment
        return callPartnerApi('appbind/dwollapayment/' + extPayoutId,
                              'GET',
                              null);
      })
      .then(response => {
        return response.json();
      })
      .then(jresp => {
        // let theStatus = jresp.status;
        let theMessage = jresp.message;

        this.setState({ saveSnackbarOpen: true, saveStatus: 'success', saveMessage: theMessage, saveSnackbarDuration: 5000 });
      })
      .catch(err => {
        let sbmesg = '';
        if (err.error != null) {
          sbmesg = 'Error in payment lookup: ' + err.error;
        } else {
          sbmesg = 'Unidentified error in payment lookup';
        }
        this.setState({ saveSnackbarOpen: true, saveStatus: 'error', saveMessage: sbmesg, saveSnackbarDuration: null });
      });
    } else if (extSource === 'stripe') {
      Promise.resolve()
      .then(() => {
        // Receive payments in the payout
        return callPartnerApi('appbind/stripepayout/' + extPayoutId,
                              'GET',
                              null);
      })
      .then(response => {
        return response.json();
      })
      .then(jresp => {
        let sbmesg = '';
        if (jresp.pcount != null) {
          sbmesg = 'Payout included ' + jresp.pcount + ' charge payments.  Refresh the page to update.';
        } else {
          sbmesg = 'Payout information unavailable';
        }
        this.setState({ saveSnackbarOpen: true, saveStatus: 'success', saveMessage: sbmesg, saveSnackbarDuration: 5000 });

      })
      .catch(err => {
        let sbmesg = '';
        if (err.error != null) {
          sbmesg = 'Error in payout charge payment lookup: ' + err.error;
        } else {
          sbmesg = 'Unidentified error in payout charge payment lookup';
        }
        this.setState({ saveSnackbarOpen: true, saveStatus: 'error', saveMessage: sbmesg, saveSnackbarDuration: null });
      });

    } else if (extSource === 'vpayout') {
      Promise.resolve()
      .then(() => {

        let aPjwt = abEnvironment.getPjwt();
        let payload = {
          operation: "initiateVendorPayout",
          params: {
            pJwt: aPjwt,
            vendorPayoutId: extPayoutId
          }
        };
    
        // initiate a vendor payout
        return callPartnerApi('appbind/generic', 'POST', payload);
      })
      .then(response => {
        return response.json();
      })
      .then(jresp => {
        let sbmesg = '';
        let status = 0;
        if (jresp.abMessage != null) {
          sbmesg = jresp.abMessage;
        } else {
          sbmesg = 'Initiated';
        }
        if (jresp.data && jresp.data.status) {
          status =jresp.data.status;
          if (status !== 0) {
            sbmesg = jresp.data.message;
          }
        }

        if (status === 0) {
          this.setState({ saveSnackbarOpen: true, saveStatus: 'success', saveMessage: sbmesg, saveSnackbarDuration: 5000 });
        } else {
          this.setState({ saveSnackbarOpen: true, saveStatus: 'error', saveMessage: sbmesg, saveSnackbarDuration: null });
        }

      })
      .catch(err => {
        let sbmesg = '';
        if (err.error != null) {
          sbmesg = 'Error in payout charge payment lookup: ' + err.error;
        } else {
          sbmesg = 'Unidentified error in payout charge payment lookup';
        }
        this.setState({ saveSnackbarOpen: true, saveStatus: 'error', saveMessage: sbmesg, saveSnackbarDuration: null });
      });

    } else {
      this.setState({ saveSnackbarOpen: true, saveStatus: 'error', saveMessage: 'That is not supported', saveSnackbarDuration: null });
    }
  }

  _onSnackbarClose() {
    this.setState( {saveSnackbarOpen: false, saveStatus: '', saveMessage: '', saveSnackbarDuration: null });
  }

  render() {
    const { isAuthenticatedAppBind, logError } = this.props.auth;
    const classes = this.props.classes;

    if (!isAuthenticatedAppBind()) { 
      return ( <Redirect to='/home' /> );
    }    

    // Determine the offset
    let offset = 0;
    if (this.state.page > 0)
    {
      offset = this.state.page * this.state.rowsPerPage
    }
    let first = this.state.rowsPerPage;

    let totalCount = 0;
    let theTitle = 'Transactions';

    let theExtSource = this.state.extSource;
    if (theExtSource === 'choose')
      theExtSource = null;

    let theTransactionType = this.state.transactionType;
    if (theTransactionType === -1)
      theTransactionType = null;

    let theTransactionId = this.state.extTransactionId;
    if (theTransactionId === '')
      theTransactionId = null;

    let disableAddPayment = false;
    if (this.state.extSource2 == null || this.state.extPayoutId == null || 
        this.state.extSource2 === 'choose' || this.state.extPayoutId === '')
      disableAddPayment = true;

    return (
      <div className={classes.root}>
        <PageTitle title={theTitle}/>
        <Grid container spacing={1} justifyContent="space-between">
          <Grid item xs={12}>
            <Typography variant="h6" style={AppBindStyles.sectionTitleFirst}>
              Receive Payout
            </Typography>
          </Grid>
          <Grid item>
            <Grid container spacing={1}>
              <Grid item className={classes.searchCaption}>
                <FormControl variant="standard" className={classes.selectSearch}>
                  <InputLabel shrink htmlFor="extSource2">External Source</InputLabel>
                  <Select
                    value={this.state.extSource2}
                    onChange={ this.handleChange('extSource2') }
                    inputProps={{
                      name: 'ext-source2',
                      id: 'ext-source2'
                    }}
                    displayEmpty
                  >
                    <MenuItem value='dwolla'>Dwolla</MenuItem>
                    <MenuItem value='stripe'>Stripe</MenuItem>
                    <MenuItem value='vpayout'>Vendor payout</MenuItem>
                    <MenuItem value='choose'>Choose One</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item>
                <SearchField
                    id="ext-pid"
                    label="External Payout Id"
                    value={this.state.extPayoutId}
                    onChange={this.handleChange('extPayoutId')}
                  />

              </Grid>
              <Grid item>
                <SaveButton
                  label='Receive Payout'
                  snackbarOpen={this.state.saveSnackbarOpen}
                  autoHideDuration={this.state.saveSnackbarDuration}
                  onSaveClick={() => { this.enterPayoutReceipts(); }}
                  onSnackbarClose={() => { this._onSnackbarClose(); }}
                  status={this.state.saveStatus}
                  message={this.state.saveMessage}
                  disabled={disableAddPayment}/>
               </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" style={AppBindStyles.sectionTitle}>
              Search Transactions
            </Typography>
          </Grid>
          <Grid item>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <SearchField
                    id="ext-tid"
                    label="External Transaction Id"
                    value={this.state.extTransactionId}
                    onChange={this.handleChange('extTransactionId')}
                  />

              </Grid>
              <Grid item className={classes.searchCaption}>
                <FormControl variant="standard" className={classes.selectSearch}>
                  <InputLabel shrink htmlFor="extSource">External Source</InputLabel>
                  <Select
                    value={this.state.extSource}
                    onChange={ this.handleChange('extSource') }
                    inputProps={{
                      name: 'ext-source',
                      id: 'ext-source'
                    }}
                    displayEmpty
                  >
                    <MenuItem value='choose'>Any</MenuItem>
                    <MenuItem value='dwolla'>Dwolla</MenuItem>
                    <MenuItem value='stripe'>Stripe</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item className={classes.searchCaption}>
                <FormControl variant="standard" className={classes.selectSearchWide}>
                  <InputLabel shrink htmlFor="transaction-type">Transaction Type</InputLabel>
                  <Select
                    value={this.state.transactionType}
                    onChange={ this.handleChange('transactionType') }
                    inputProps={{
                      name: 'transaction-type',
                      id: 'transaction-type'
                    }}
                  >
                    <MenuItem value={-1}>Any</MenuItem>
                    <MenuItem value={0}>Bill Bindcard</MenuItem>
                    <MenuItem value={1}>Charge Funding Source</MenuItem>
                    <MenuItem value={2}>Receive Payment</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item className={classes.searchCaption}>
                <FormControl variant="standard" className={classes.selectSearchWide}>
                  <InputLabel shrink htmlFor="mode">Mode</InputLabel>
                  <Select
                    value={this.state.mode}
                    onChange={ this.handleChange('mode') }
                    inputProps={{
                      name: 'mode',
                      id: 'mode'
                    }}
                  >
                    <MenuItem value={0}>All</MenuItem>
                    <MenuItem value={1}>Without Subsequent</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item>
                <div style={AppBindStyles.datePickerField}>
                <DatePicker
                  autoOk
                  label="From Date"
                  value={this.state.startDate}
                  onChange={(date) => this.setFromDate(date) }
                  className={classes.textField2}
                  format="YYYY-MM-DD"
                  disableFuture
                  renderInput={(params) => <TextField {...params} />}
                />
                </div>
              </Grid>
              <Grid item>
                <div style={AppBindStyles.datePickerField}>
                <DatePicker
                  autoOk
                  label="To Date"
                  value={this.state.endDate}
                  onChange={(date) => this.setToDate(date) }
                  className={classes.textField2}
                  format="YYYY-MM-DD"
                  disableFuture
                  renderInput={(params) => <TextField {...params} />}
                />
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <QueryRenderer
          environment={abEnvironment.getEnvironment()}
          query={TransactionsQuery}
          variables={{extsource: theExtSource,
                      exttransactionid: theTransactionId,
                      mode: this.state.mode,
                      transactiontype: theTransactionType,
                      startDate: this.state.queryStartDateUtc,
                      endDate: this.state.queryEndDateUtc,
                      first: first,
                      offset: offset}}
          render={({error, props})=> {
            if (error) {
              logError(error.message);
              return (
                <ServerError/>
              );
            } else if (props) {
              // Determine offset information
              totalCount = props.lookuptransactions.totalCount;

              return (
                <div style={{marginTop: 8, marginBottom: 2}}>
                  <Typography>Found {totalCount} transactions</Typography>
                  <div className={classes.paper}>
                    <Table>
                      <TableHead className={classes.tblHead}>
                        <TableRow className={classes.tblHeadRow}>
                          <TableCell className={classes.tblHeadCell}>Date</TableCell>
                          <TableCell className={classes.tblHeadCell}>Type</TableCell>
                          <TableCell className={classes.tblHeadCell}>Description</TableCell>
                          <TableCell className={classes.tblHeadCell}>Ext</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        { props.lookuptransactions.nodes.map(n => {
                          let ttype = n.transactionType;
                          let ttypeText = 'Other';
                          if (ttype === 0) {
                            ttypeText = 'BindCard Charged';
                          } else if (ttype === 1) {
                            ttypeText = 'AppBind Billing';
                          } else if (ttype === 2) {
                            ttypeText = 'Payment Received';
                          }
                          let transactionLink = "transaction?transactionId=" + n.transactionId;

                          return (
                            <TableRow key={n.transactionId}>
                              <TableCell onClick={() => {this.goTo(transactionLink);}}>{n.transactionTime}</TableCell>
                              <TableCell>{ttypeText}</TableCell>
                              <TableCell>{n.description}</TableCell>
                              <TableCell>{n.extSource}: {n.extTransactionId}</TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </div>
                  <div style={AppBindStyles.paginationTableFooter}>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      component="div"
                      count={totalCount}
                      rowsPerPage={this.state.rowsPerPage}
                      page={this.state.page}
                      backIconButtonProps={{
                        'aria-label': 'Previous Page',
                      }}
                      nextIconButtonProps={{
                        'aria-label': 'Next Page',
                      }}
                      onPageChange={this.handleChangePage}
                      onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />                        
                  </div>
                </div>
              )
            }
            return (
              <LoadingSpinner />
            );
          }}
        />
      </div>
    );
  }
}
  
Transactions.propTypes = {
  classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(Transactions);
